module.exports = __webpack_public_path__ + "img/check-selected.8a876d84.svg";